import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// import * as Sentry from "@sentry/react";
// Sentry disabled for improved performance - can be re-enabled when monitoring is needed
import App from './App';
import GlobalStyles from './assets/styles/GlobalStyles';
import { ToastContainer } from 'react-toastify';
// import { setupSentryAxiosInterceptor } from './utils/sentryAxiosInterceptor';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/rtl.css';
import './styles/tailwind-utilities.css';
import './styles/rtl-additions.css';

const TIKTOK_PIXEL_ID = 'D67P0Q3C77U2V3Q5ID9G';

const initTikTokPixel = () => {
  if (typeof window === 'undefined') return;
  if (window.ttq && window.ttq._isInitialized) {
    window.ttq.page();
    return;
  }

  const ttq = window.ttq || [];
  window.ttq = ttq;
  ttq._isInitialized = true;
  window.TiktokAnalyticsObject = 'ttq';
  ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie'];
  ttq.setAndDefer = function (t, e) {
    t[e] = function () {
      t.push([e].concat([].slice.call(arguments, 0)));
    };
  };
  for (let i = 0; i < ttq.methods.length; i += 1) {
    ttq.setAndDefer(ttq, ttq.methods[i]);
  }
  ttq.instance = function (t) {
    const e = ttq._i[t] || [];
    for (let n = 0; n < ttq.methods.length; n += 1) {
      ttq.setAndDefer(e, ttq.methods[n]);
    }
    return e;
  };
  ttq.load = function (e, n) {
    const i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
    ttq._i = ttq._i || {};
    ttq._i[e] = [];
    ttq._i[e]._u = i;
    ttq._t = ttq._t || {};
    ttq._t[e] = +new Date();
    ttq._o = ttq._o || {};
    ttq._o[e] = n || {};
    const o = document.createElement('script');
    o.type = 'text/javascript';
    o.async = true;
    o.src = `${i}?sdkid=${e}&lib=ttq`;
    const a = document.getElementsByTagName('script')[0];
    if (a && a.parentNode) {
      a.parentNode.insertBefore(o, a);
    } else {
      document.head.appendChild(o);
    }
  };
  ttq.load(TIKTOK_PIXEL_ID);
  ttq.page();
};

initTikTokPixel();

// Initialize Sentry for error tracking and performance monitoring
// DISABLED: Sentry initialization commented out to improve performance
// Uncomment the following lines to enable Sentry monitoring
/*
Sentry.init({
  dsn: "https://394c1d83bf28462a5ea3cfff45a98517@o4510287757967360.ingest.de.sentry.io/4510287759867984",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,
  environment: process.env.NODE_ENV || 'development',
});

setupSentryAxiosInterceptor();
*/

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <GlobalStyles />
      <ToastContainer 
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
